export default function emitUserStateChange() {
  window.dispatchEvent(new Event("user-state-change"));
}
